export default __webpack_public_path__ + "static/media/bbDAI+.1d21c08c.png";